import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TokenexSlice = {
  showErrorModal: boolean;
};

const initialState = {
  showErrorModal: false,
} as TokenexSlice;

const tokenexSlice = createSlice({
  name: 'tokenexSlice',
  initialState,
  reducers: {
    setTokenexErrorModalStatus(state, { payload: showErrorModal }: PayloadAction<boolean>) {
      state.showErrorModal = showErrorModal;
    },
  },
});

export const { setTokenexErrorModalStatus } = tokenexSlice.actions;
export default tokenexSlice;
